export const loggedInPracticeIdsStorageKey = "loggedInPracticeIds";
export const activeLoggedInPracticeIdStorageKey = "activeLoggedInPracticeId";
